export default __webpack_public_path__ + "static/media/pic3.c55c0c37.jpg";